<script lang="ts">
  export let step: number;
  export let pollsSum: number;
  export let showSteps: boolean = true;
  export let title: string = 'Fill out the form so we can better assist you.';

  $: totalSteps = pollsSum + 1;
  $: steps = Array.from({ length: totalSteps }, (_, i) => i + 1);
</script>

<div class="flex flex-col items-center justify-center gap-2.5">
  <h3
    class="!mb-5 text-center text-2xl font-bold leading-[1.3] text-[#161C24] md:!mb-10 md:text-[32px]"
  >
    {@html title}
  </h3>
  {#if showSteps}
    <div class="mb-3 mb-5 flex w-full items-center justify-center md:mb-8">
      {#each steps as stepNumber, index}
        <div
          class="flex flex-col items-center"
          class:flex-1={index < steps.length - 1}
        >
          <div class="mb-1 flex w-full items-center">
            <div
              class="flex h-6 w-6 min-w-6 items-center justify-center rounded-full border {stepNumber ===
              step
                ? 'border-[#086CD9]'
                : stepNumber < step
                  ? 'border-transparent bg-[#086CD9]'
                  : 'border-[#D1D5DB]'}"
            >
              {#if stepNumber === step}
                <span class="h-2 w-2 rounded-full bg-[#086CD9]"></span>
              {:else if stepNumber < step}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M3.625 8.625L6.125 11.125L12.375 4.875"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              {/if}
            </div>
            {#if index < steps.length - 1}
              <div
                class="relative h-[2px] w-auto flex-1 {stepNumber < step
                  ? 'bg-[#086CD9]'
                  : 'bg-[#D1D5DB]'}"
              ></div>
            {/if}
          </div>
          <p class="w-full text-xs font-medium !text-[#586272]">
            Step {stepNumber}
          </p>
        </div>
      {/each}
    </div>
  {/if}
</div>
